// Maps a Predictus `legal_branch_slug` to a Material Symbols icon + a pt-BR label
// used for the tooltip next to the legal-branch icon in the processes table.

export interface LegalBranchMeta {
  label: string;
  icon: string;
}

export const LEGAL_BRANCH_BY_SLUG: Record<string, LegalBranchMeta> = {
  criminal: { label: 'Direito Penal', icon: 'gavel' },
  social_security: { label: 'Direito Previdenciário', icon: 'elderly' },
  consumer: { label: 'Direito do Consumidor', icon: 'shopping_cart' },
  tax: { label: 'Direito Tributário', icon: 'receipt_long' },
  administrative_public: { label: 'Direito Administrativo / Público', icon: 'account_balance' },
  environmental: { label: 'Direito Ambiental', icon: 'eco' },
  civil: { label: 'Direito Civil', icon: 'balance' },
  labor: { label: 'Direito do Trabalho', icon: 'work' },
  uncategorized: { label: 'Não categorizado', icon: 'category' },
};

const FALLBACK: LegalBranchMeta = { label: 'Não categorizado', icon: 'category' };

export function getLegalBranchMeta(
  slug: string | null | undefined,
  text?: string | null,
): LegalBranchMeta {
  if (slug && LEGAL_BRANCH_BY_SLUG[slug]) {
    return LEGAL_BRANCH_BY_SLUG[slug];
  }
  // Unknown/absent slug: keep the icon generic but prefer the source label if present.
  return { label: text?.trim() || FALLBACK.label, icon: FALLBACK.icon };
}
